module.exports = __webpack_public_path__ + "img/klarna-ratenkauf-alt.055ab162.png";